import script from "./StudentPercentage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentPercentage.vue?vue&type=script&setup=true&lang=ts"

import "./StudentPercentage.vue?vue&type=style&index=0&id=c6c1e0d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6c1e0d0"]])

export default __exports__